import Vue from "vue";
import VueI18n from "vue-i18n";

Vue.use(VueI18n); // 全局挂载

export const i18n = new VueI18n({
  locale: localStorage.getItem("sof_locale") || "en", // 从localStorage中获取 默认英文
  messages: {
    kr: require("./lan/pt"), // pt语言包
    jp: require("./lan/es"), // sp语言包
    fr: require("./lan/fr"), // fr语言包
    de: require("./lan/de"), // de语言包
    en: require("./lan/en"), // 英文语言包
    cn: require("./lan/cn") // 简体语言语言包

  }
});

export default i18n;


// WEBPACK FOOTER //
// ./src/i18n/index.js